/**
 * CODE_COMMENTS_31
 */

// CODE_COMMENTS_58
export const REPORT_BUYBACK_SHIPMENTS_FIELD_ARRAY_NAME_RESALE = 'resale'
export const REPORT_BUYBACK_SHIPMENTS_FIELD_ARRAY_NAME_BEER_OUT_OF_CODE = 'outOfCode'
export const REPORT_BUYBACK_SHIPMENTS_FIELD_ARRAY_NAME_DEFECTIVE_KEG = 'defectiveKeg'
